import { render } from "./NewsListComponent.vue?vue&type=template&id=98a0d1ac"
import script from "./NewsListComponent.vue?vue&type=script&lang=js"
export * from "./NewsListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__